import type { URLSearchParamsQuery } from '@/types';

interface Options {
  method: 'GET' | 'POST';
  payload?: Record<string, unknown>;
  query?: URLSearchParamsQuery;
}

// 429 is for rate limiting
const statusCodesToAccept = [200, 201, 204, 429];

export const queryEndpoint = async (
  endpoint: string,
  { method, payload, query }: Options,
) => {
  const hasQuery = Boolean(query);
  const queryString = hasQuery
    ? `?${new URLSearchParams(query).toString()}`
    : '';

  const response = await fetch(endpoint + queryString, {
    method,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!statusCodesToAccept.includes(response.status)) {
    throw new Error(`Response status: ${response.status}`);
  }

  const json = await response.json();

  return json;
};
